/* ==========================================================================
   UiPanel > Prototype
   ========================================================================== */

// Imports
const { addToStore, removeFromStore } = require('@bluekiri/alexandria/helpers/store');

// Store
let store = [];

// Prototype
const uipanelPrototype = {
    /* Add triggers */
    addTriggers: function Fn(triggers) {
        triggers.forEach(trigger => {
            this.bindEvents();
            trigger.addEventListener('click', this.onClickTrigger);
        });
    },

    /* Set close button */
    setClose: function Fn() {
        if (!this.config.hasClose) return this;

        this.closeElement = this.element.querySelector(`[${this.config.panelClose}]`);

        return this;
    },

    /* Is open status */
    isOpen: function Fn() {
        return this.isVisible;
    },

    // Display
    display: function Fn() {
        this.element.setAttribute('aria-hidden', 'false');
        this.element.classList.add(this.config.cssVisible);
        this.isVisible = true;
        this.addEventListener();

        // Fire external callbacks before open panel
        this.onOpen();

        return this;
    },

    // Hide
    hide: function Fn() {
        this.element.setAttribute('aria-hidden', 'true');
        this.element.classList.remove(this.config.cssVisible);
        this.isVisible = false;
        this.removeEventListener();

        /* Fire external callbacks before open panel */
        this.onClose();

        return this;
    },

    /* Add to dom */
    addToDom: function Fn() {
        /* Place it based on its trigger location */
        this.config.triggers[0].appendChild(this.element);

        return this;
    },

    /* Remove from dom */
    removeFromDom: function Fn() {
        this.element.parentNode.removeChild(this.element);

        return this;
    },

    /*  onOpen callBacks */
    onOpen: function Fn(event = false) {
        /* Fire external callbacks */
        if (this.config.onOpen) this.config.onOpen.call(this, this, event);

        return this;
    },

    /*  onClose callBacks */
    onClose: function Fn(event = false) {
        /* Fire external callbacks */
        if (this.config.onClose) this.config.onClose.call(this, this, event);

        return this;
    },

    /* onClick callbacks */
    onClick: function Fn(event = false) {
        /* Fire external callbacks */
        if (this.config.onClick) this.config.onClick.call(this, this, event);

        return this;
    },

    /* On click close */
    onClickClose: function Fn(event) {
        /* Hide */
        this.hide();

        /* Prevent bubbling */
        event.stopPropagation();
        event.preventDefault();

        return this;
    },

    /* On key down */
    onKeydown: function Fn(event) {
        /* Esc key */
        if (!(event.keyCode === 27)) return this;

        /* Hide */
        this.hide();

        /* Prevent bubbling */
        event.stopPropagation();

        return this;
    },

    // On click trigger
    onClickTrigger: function Fn(event) {
        // Trigger visibility
        if (!this.isVisible) {
            this.display();
        } else {
            this.hide();
        }

        // Hide other uipanels by using the store
        store.filter(item => item.isVisible && item !== this).forEach(item => item.hide());

        // Prevent bubbling
        event.stopPropagation();

        return this;
    },

    /* On click panel */
    onClickPanel: function Fn(event) {
        /* Fire callbacks */
        this.onClick();

        /* Prevent bubbling */
        event.stopPropagation();

        return this;
    },

    // On click window
    onClickWindow: function Fn() {
        // Hide uipanel open
        this.hide();

        return this;
    },

    // Bind events
    bindEvents: function Fn() {
        this.onKeydown = this.onKeydown.bind(this);
        this.onClickTrigger = this.onClickTrigger.bind(this);
        this.onClickWindow = this.onClickWindow.bind(this);
        this.onClickPanel = this.onClickPanel.bind(this);
        this.onClickClose = this.onClickClose.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onClick = this.onClick.bind(this);

        return this;
    },

    // Remove event listener
    removeEventListener: function Fn() {
        this.element.removeEventListener('click', this.onClickPanel);

        if (this.config.hasClose) this.closeElement.removeEventListener('click', this.onClickClose);

        // Window
        document.removeEventListener('click', this.onClickWindow);
        document.removeEventListener('keydown', this.onKeydown);

        return this;
    },

    // Add event listener
    addEventListener: function Fn() {
        // Bind events before adding
        this.bindEvents();

        this.element.addEventListener('click', this.onClickPanel);
        if (this.config.hasClose) this.closeElement.addEventListener('click', this.onClickClose);

        // Window
        document.addEventListener('click', this.onClickWindow);
        document.addEventListener('keydown', this.onKeydown);

        return this;
    },

    // Add to store
    addToStore: function Fn() {
        /* Control unique instances of same panel */
        if (this.getStore().filter(item => item.type === this.type).length > 0) return this;

        /* Quarry function */
        addToStore(this, store);

        return this;
    },

    // Remove from store
    removeFromStore: function Fn() {
        store = removeFromStore(this, store);

        return this;
    },

    /* Get store */
    getStore: function Fn() {
        return store;
    },

    // Init
    init: function Fn() {
        /* Set close button */
        this.setClose();

        /* Add triggers */
        if (this.config.triggers.length > 0) {
            this.addTriggers(this.config.triggers);

            /* Place it correctly in dom */
            if (this.config.autoDom) {
                this.removeFromDom();
                this.addToDom();
            }
        }

        // Add uipanel to the store
        if (this.config.autoStore) this.addToStore();

        return this;
    }
};

module.exports = uipanelPrototype;
